import Breadcrumbs from "@mui/material/Breadcrumbs";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return <Breadcrumbs key={component.id} />;
}

export default Component;
